import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const CANVAS_NODE_GENERIC: ObjectTypeConfig = {
  actions: [
    {
      id: "chat-about",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
      hiddenWhen: { kind: { nodeType: "chat-session" } },
    },
    // Text notes carry a title pill like sections, so they get the same
    // Rename affordance. Rendered by the bespoke TextNoteFloatingToolbar;
    // gated here to text notes so shapes/widgets don't inherit it.
    {
      id: "rename",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
      hiddenWhen: { not: { kind: { nodeType: "text-note" } } },
    },
    {
      id: "copy",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
      disabledWhen: predicates.copyDisabled,
    },
    {
      id: "bring-to-front",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
      disabledWhen: predicates.zOrderDisabled,
    },
    {
      id: "send-to-back",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
      disabledWhen: predicates.zOrderDisabled,
    },
    // Hide is the non-destructive counterpart to delete: the node stays (a
    // file entity keeps its canvas membership) — the surface just stops
    // rendering it. Un-hiding lives on the canvas rail ("Show on canvas").
    {
      id: "remove-from-canvas",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
      hiddenWhen: { state: "hiddenOnCanvas" },
    },
    {
      id: "delete",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
    },
  ],
};

export const CANVAS_NODE_SECTION: ObjectTypeConfig = {
  actions: [
    {
      id: "chat-about",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
    },
    {
      id: "rename",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
    },
    {
      id: "copy",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
    },
    {
      id: "delete-wrapper-only",
      surfaces: ["context-menu", "floating-toolbar"],
      presentation: {
        "context-menu": "menu-item",
        "floating-toolbar": "toolbar-more-submenu",
      },
    },
    {
      id: "delete",
      surfaces: ["floating-toolbar", "context-menu"],
      presentation: {
        "floating-toolbar": "toolbar-more-submenu",
        "context-menu": "menu-item",
      },
    },
    {
      id: "bring-to-front",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.zOrderDisabled,
    },
    {
      id: "send-to-back",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.zOrderDisabled,
    },
  ],
};

export const CANVAS_NODE_CHAT_SESSION: ObjectTypeConfig = {
  actions: [
    {
      id: "open",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
    },
    {
      id: "remove-from-canvas",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      hiddenWhen: { state: "hiddenOnCanvas" },
    },
    {
      id: "delete",
      surfaces: ["floating-toolbar", "context-menu"],
      presentation: {
        "floating-toolbar": "toolbar-primary",
        "context-menu": "menu-item",
      },
    },
    {
      id: "copy",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.copyDisabled,
    },
    {
      id: "bring-to-front",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.zOrderDisabled,
    },
    {
      id: "send-to-back",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.zOrderDisabled,
    },
  ],
};

export const CANVAS_NODE_CONNECTOR: ObjectTypeConfig = {
  actions: [
    // Connectors copy (useCopyPaste remaps their endpoints on paste) and stack
    // like any other node — only sections and chat sessions are z-order
    // ineligible — so they get the same organization/order entries as the
    // generic nodes.
    {
      id: "copy",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.copyDisabled,
    },
    {
      id: "bring-to-front",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.zOrderDisabled,
    },
    {
      id: "send-to-back",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      disabledWhen: predicates.zOrderDisabled,
    },
    {
      id: "remove-from-canvas",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      hiddenWhen: { state: "hiddenOnCanvas" },
    },
    {
      id: "delete",
      surfaces: ["floating-toolbar", "context-menu"],
      presentation: {
        "floating-toolbar": "toolbar-primary",
        "context-menu": "menu-item",
      },
    },
  ],
};

export const CANVAS_EDGE: ObjectTypeConfig = {
  actions: [
    {
      id: "delete",
      surfaces: ["floating-toolbar"],
      presentation: "toolbar-primary",
    },
  ],
};
